// 機能フラグ（運用状況に応じて表示/非表示を切替）
// 季節のおすすめページ: 運用可能になったら true に戻すと顧客画面に再表示される
export const SEASONAL_RECOMMENDATIONS_ENABLED = false;
